import { ICofsClient, CofsClient } from '@atlassiansox/asc-cofs';
import React, { createContext, PropsWithChildren, useContext } from 'react';

const CofsClientContext = createContext<ICofsClient>(new CofsClient());

export function useCofsClient(): ICofsClient {
  return useContext(CofsClientContext);
}

export type CofsClientProviderProps = PropsWithChildren<{
  readonly client: ICofsClient;
}>;

export function CofsClientProvider({
  client,
  children
}: CofsClientProviderProps) {
  return (
    <CofsClientContext.Provider value={client}>
      {children}
    </CofsClientContext.Provider>
  );
}
